export const getEnvUrl = () => {
  if (typeof window !== 'undefined') {
    if (window.location.origin.includes('website.dev.payfit.tech')) {
      return (
        window.location.origin + '/' + window.location.pathname.split('/')[1]
      );
    }
  }
  return '';
};

export const emptyUrl = `${getEnvUrl()}/icon/empty.svg`;

export const getColor = (variant: string | undefined) => {
  let color = 'text-[#768599]';
  if (variant)
    color = ['dark', 'white'].includes(variant)
      ? 'text-white'
      : 'text-[#0F6FDE]';
  return color;
};
